
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/checkout/[product_id]",
      function () {
        return require("private-next-pages/checkout/[product_id].tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/checkout/[product_id]"])
      });
    }
  